import { FC } from "react";
import { Outlet } from "react-router-dom";

import { HeaderComponent } from "../../components/header.component.tsx";

export const ProtectedLayout: FC = () => {
  return (
    <>
      <HeaderComponent />
      <Outlet />
    </>
  );
};
